<template>
  <div
    class="hermes-banner-wrapper banner-wrapper margin-bottom-xs"
    role="img"
    aria-label="Hermes logo is being displayed in the banner"
  >
    <img
      :src="imgSrc"
      class="hermes-banner"
      alt="Hermes Banner"
    >
  </div>
</template>
<script setup>
import hermesBcomImg from '../../assets/img/hermes.png';
import { useBrand } from '../../composables/useBrand';

const { isMcom } = useBrand();

const imgSrc = isMcom
  ? '/dyn_img/cat_splash/052819_BEAUTY_FRAG_HERMES_BRANDSHOP_Hermes_1356971.jpg'
  : hermesBcomImg;
</script>
<style brand="mcom" lang="scss" scoped>
  .hermes-banner {
    width: 100%;
    height: rem-calc(70);
    object-fit: cover;
  }
</style>
<style brand="bcom" lang="scss" scoped>
  @import "~settingSCSS";
  .hermes-banner-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    background: $black;
    height: rem-calc(60);
  }
  .hermes-banner {
    height: rem-calc(24);
    position: relative;
  }
  // style img alt to hide default icon
  .hermes-banner[alt]:after {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: $black;
    content: '';
  }
  @include breakpoint(medium up) {
    .hermes-banner-wrapper {
      height: rem-calc(80);
    }
    .hermes-banner {
      height: rem-calc(32);
    }
  }
</style>
